module.exports = __webpack_public_path__ + "static/assets/249fbfa7cf18a7bdf1bc83ec506bc1ef.svg";